/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Facts_TitleInputs */

const en_directory_ai_tools_facts_title = /** @type {(inputs: Directory_Ai_Tools_Facts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At a glance`)
};

const zh_directory_ai_tools_facts_title = /** @type {(inputs: Directory_Ai_Tools_Facts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一览`)
};

/**
* | output |
* | --- |
* | "At a glance" |
*
* @param {Directory_Ai_Tools_Facts_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_facts_title = /** @type {((inputs?: Directory_Ai_Tools_Facts_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Facts_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_facts_title(inputs)
	return zh_directory_ai_tools_facts_title(inputs)
});
export { directory_ai_tools_facts_title as "directory.ai_tools.facts_title" }